module.exports = __webpack_public_path__ + "img/SketchPngdb2f7464dcaa6fadbbeacb7137d6bd7804aef0bdb8bc29b6a8f10f87a29b485f.fc88df85.png";